import { recentProDayWindow } from './recentProDays';

export function recentProLink(id: string, matchDate: string) {
  return `/personal?${new URLSearchParams({ tab: 'pros', library: 'recent', date: matchDate.slice(0, 10), match: id })}`;
}

export function recentProTarget(params: URLSearchParams, now = new Date()) {
  if (!['pros', 'demos'].includes(params.get('tab') || '') || params.get('library') !== 'recent') return null;
  const day = params.get('date') || '';
  const { oldestDay, latestDay } = recentProDayWindow(now);
  const validDay = /^\d{4}-\d{2}-\d{2}$/.test(day) && !Number.isNaN(Date.parse(`${day}T12:00:00Z`))
    && new Date(`${day}T12:00:00Z`).toISOString().slice(0, 10) === day;
  return { date: validDay && day >= oldestDay && day <= latestDay ? day : latestDay,
    matchId: /^[a-zA-Z0-9-]{1,80}$/.test(params.get('match') || '') ? params.get('match')! : '' };
}
